var exports = {
  "v_": "tabContainer__Wvv9Ol",
  "Lj": "tabContent__Oq9XAI",
  "$m": "isActive__L4lWcf",
  "qo": "mainButton__ir1Y1e",
  "Pi": "activeTabIcon__3qiarj",
  "b": "closeButton__WDevJs",
  "Kk": "icon__Um1NnX",
  "DD": "title__B6guR9",
  "aw": "isEphemeral__affxMi",
  "Yj": "isClipped__Hzq44P",
  "Ed": "trailingComponent__W6yndT",
};

module.exports = exports;
